import { alpha, Box, LinearProgress } from '@mui/material';
import { MODULE_ACCENT_COLORS } from '../../../theme/module-colors';
import {
  MOTION_DURATION_MS,
  MOTION_EASING,
  motionTransition,
  REDUCED_MOTION_QUERY,
} from '../../../theme/motion';
import { WIZARD_STEP_ORDER, type WizardStep } from '../hooks/wizard-steps';

interface WizardStepperProps {
  currentStep: WizardStep;
}

const accent = MODULE_ACCENT_COLORS.goodsReceiving.main;

export function WizardStepper({ currentStep }: WizardStepperProps) {
  const currentStepIndex = WIZARD_STEP_ORDER.indexOf(currentStep);
  const totalSteps = WIZARD_STEP_ORDER.length;
  const progress = ((currentStepIndex + 1) / totalSteps) * 100;

  return (
    <Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 4,
          borderRadius: 2,
          backgroundColor: alpha(accent, 0.14),
          '& .MuiLinearProgress-bar': {
            borderRadius: 2,
            backgroundColor: accent,
            transition: motionTransition(
              ['transform'],
              MOTION_DURATION_MS.layout,
              MOTION_EASING.standard,
            ),
            [REDUCED_MOTION_QUERY]: {
              transition: 'none',
            },
          },
        }}
      />
    </Box>
  );
}
